"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuditLogPageDataProvider = exports.useAuditLogPageDataContext = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const lodash_1 = __importDefault(require("lodash"));
const use_custom_compare_1 = require("use-custom-compare");
const react_dom_1 = require("react-dom");
const react_router_dom_1 = require("react-router-dom");
const ProjectConfigStoreDataProvider_1 = require("src/configeek_assets/src/components/common/provider/ProjectConfigStoreDataProvider");
const Commons_1 = require("src/configeek_assets/src/components/common/provider/Commons");
const AuditLogPageModelProvider_1 = require("src/configeek_assets/src/components/loggedIn/content/project/data/audit/model/AuditLogPageModelProvider");
const AppRouter_1 = require("src/configeek_assets/src/components/common/AppRouter");
const isMounted_1 = __importDefault(require("src/configeek_assets/src/system/hooks/isMounted"));
const DateTimeUtils_1 = require("src/configeek_assets/src/system/mics/DateTimeUtils");
const AuditLogJSONModel_1 = require("src/configeek_assets/src/components/loggedIn/content/project/data/audit/model/AuditLogJSONModel");
const ICCanisterUtils_1 = require("src/configeek_assets/src/ic/ICCanisterUtils");
const PAGE_SIZE = process.env.NODE_ENV === "development" ? 10 : 25;
const AuditLogPageDataContext = React.createContext(undefined);
const useAuditLogPageDataContext = () => {
    const context = React.useContext(AuditLogPageDataContext);
    if (!context) {
        throw new Error("useAuditLogPageDataContext must be used within a AuditLogPageDataContext.Provider");
    }
    return context;
};
exports.useAuditLogPageDataContext = useAuditLogPageDataContext;
const AuditLogPageDataProvider = (props) => {
    var _a;
    const projectConfigStoreDataContext = (0, ProjectConfigStoreDataProvider_1.useProjectConfigStoreDataContext)();
    const isMounted = (0, isMounted_1.default)();
    const location = (0, react_router_dom_1.useLocation)();
    const history = (0, react_router_dom_1.useHistory)();
    const [state, setState] = (0, react_1.useReducer)(Commons_1.simpleFeatureReducer, (0, Commons_1.getDefaultCGFeature)());
    const [urlState, setURLState] = (0, react_1.useReducer)((state, newState) => ({ ...state, ...newState }), (0, AuditLogPageModelProvider_1.deserializeJSONModelFromQueryString)(location.search).serialize());
    const serializedStateData = (0, react_1.useMemo)(() => {
        const jsonModelFromURL = (0, AuditLogPageModelProvider_1.deserializeJSONModelFromQueryString)(location.search);
        const serializedState = jsonModelFromURL.serialize();
        const serializedStateView = serializedState.view;
        serializedState.view = undefined;
        return {
            serializedState: serializedState,
            serializedStateView: serializedStateView
        };
    }, [location.search]);
    ////////////////////////////////////////////////
    // Change URL state only when View changes.
    ////////////////////////////////////////////////
    (0, use_custom_compare_1.useCustomCompareEffect)(() => {
        const jsonModelFromURL = (0, AuditLogPageModelProvider_1.deserializeJSONModelFromQueryString)(location.search);
        setURLState(jsonModelFromURL.serialize());
    }, [serializedStateData.serializedStateView, isMounted], lodash_1.default.isEqual);
    ////////////////////////////////////////////////
    // Fetch data on page URL state change
    ////////////////////////////////////////////////
    (0, use_custom_compare_1.useCustomCompareEffect)(() => {
        if (isMounted()) {
            (async () => {
                const jsonModel = (0, AuditLogPageModelProvider_1.deserializeJSONModelFromQueryString)(location.search);
                try {
                    (0, react_dom_1.unstable_batchedUpdates)(() => {
                        setState({ status: { inProgress: true } });
                    });
                    // if (process.env.NODE_ENV === "development") {
                    //     await delayPromise(2000)
                    // }
                    const newState = {};
                    const state_keyFilter = jsonModel.getKeyFilter().getValue();
                    const state_valueFilter = jsonModel.getValueFilter().getValue();
                    const state_timeFilter = jsonModel.getTimeFilter().getValue();
                    const state_order = jsonModel.getOrderValue();
                    const pageSize = PAGE_SIZE;
                    const orderDescending = state_order === "descending";
                    const keyFilter = lodash_1.default.isEmpty(state_keyFilter) ? undefined : state_keyFilter;
                    const valueFilter = lodash_1.default.isEmpty(state_valueFilter) ? undefined : state_valueFilter;
                    const timeFilterSeconds = state_timeFilter == undefined ? undefined : Math.floor(state_timeFilter / 1000);
                    const auditRequest = {
                        updateId: [],
                        count: pageSize,
                        orderDescending: orderDescending,
                        timeFilter: (0, ICCanisterUtils_1.createICOptional)(timeFilterSeconds),
                        keyFilter: (0, ICCanisterUtils_1.createICOptional)(keyFilter),
                        valueFilter: (0, ICCanisterUtils_1.createICOptional)(valueFilter),
                    };
                    if (!!process.env.IS_TEST_SERVER) {
                        console.log("auditRequest", auditRequest);
                    }
                    const result = await projectConfigStoreDataContext.fetchAuditLog(auditRequest);
                    newState.status = { inProgress: false, loaded: true };
                    switch (result.status) {
                        case "success": {
                            newState.error = { isError: false, error: undefined };
                            newState.data = {
                                auditLogRecords: result.result.records,
                                noMoreRecords: !result.result.haveMore
                            };
                            newState.time = { updatedAt: DateTimeUtils_1.DateTimeUtils.now() };
                            break;
                        }
                        case "error": {
                            if (!!process.env.IS_TEST_SERVER) {
                                console.error("auditRequest failed!", result.reason);
                            }
                            newState.error = { error: new Error(result.reason), isError: true };
                            newState.data = undefined;
                            break;
                        }
                        case "unknownError": {
                            newState.error = { error: result.error, isError: true };
                            newState.data = undefined;
                            break;
                        }
                        default: {
                            newState.error = { error: new Error("unknown"), isError: true };
                            newState.data = undefined;
                        }
                    }
                    (0, react_dom_1.unstable_batchedUpdates)(() => {
                        setURLState(jsonModel.serialize());
                        setState(newState);
                    });
                }
                catch (e) {
                    const newState = {
                        status: { inProgress: false, loaded: true },
                        error: { isError: true, error: e },
                        data: undefined
                    };
                    (0, react_dom_1.unstable_batchedUpdates)(() => {
                        setURLState(jsonModel.serialize());
                        setState(newState);
                    });
                }
            })();
        }
    }, [serializedStateData.serializedState, isMounted, projectConfigStoreDataContext.fetchAuditLog], lodash_1.default.isEqual);
    ////////////////////////////////////////////////
    // Get URL JSON Model
    ////////////////////////////////////////////////
    const getURLJSONModel = (0, use_custom_compare_1.useCustomCompareCallback)(() => {
        return new AuditLogJSONModel_1.AuditLogJSONModel(urlState);
    }, [urlState], lodash_1.default.isEqual);
    ////////////////////////////////////////////////
    // On View Changed
    ////////////////////////////////////////////////
    const onViewChanged = (0, use_custom_compare_1.useCustomCompareCallback)((view) => {
        // console.log("onViewChanged: new view", view);
        const jsonModel = new AuditLogJSONModel_1.AuditLogJSONModel(urlState);
        jsonModel.getView().overwriteFromSerializedState(view);
        const serializedState = jsonModel.serialize();
        // console.log("onViewChanged: serializedState", serializedState);
        const newUrl = AppRouter_1.PathGenerator.project(props.projectApiKey, "auditLog", serializedState);
        // console.log("onViewChanged: newUrl", newUrl);
        history.push(newUrl);
    }, [urlState, props.projectApiKey], lodash_1.default.isEqual);
    ////////////////////////////////////////////////
    // Load More
    ////////////////////////////////////////////////
    const onLoadMore = (0, use_custom_compare_1.useCustomCompareCallback)(async (updateId) => {
        var _a;
        const jsonModel = new AuditLogJSONModel_1.AuditLogJSONModel(urlState);
        try {
            (0, react_dom_1.unstable_batchedUpdates)(() => {
                setState({ status: { inProgress: true } });
            });
            // if (process.env.NODE_ENV === "development") {
            //     await delayPromise(2000)
            // }
            const newState = {};
            const state_keyFilter = jsonModel.getKeyFilter().getValue();
            const state_valueFilter = jsonModel.getValueFilter().getValue();
            const state_timeFilter = jsonModel.getTimeFilter().getValue();
            const state_order = jsonModel.getOrderValue();
            const pageSize = PAGE_SIZE;
            const orderDescending = state_order === "descending";
            const keyFilter = lodash_1.default.isEmpty(state_keyFilter) ? undefined : state_keyFilter;
            const valueFilter = lodash_1.default.isEmpty(state_valueFilter) ? undefined : state_valueFilter;
            const timeFilterSeconds = state_timeFilter == undefined ? undefined : Math.floor(state_timeFilter / 1000);
            const auditRequest = {
                updateId: (0, ICCanisterUtils_1.createICOptional)(updateId),
                count: pageSize,
                orderDescending: orderDescending,
                timeFilter: (0, ICCanisterUtils_1.createICOptional)(timeFilterSeconds),
                keyFilter: (0, ICCanisterUtils_1.createICOptional)(keyFilter),
                valueFilter: (0, ICCanisterUtils_1.createICOptional)(valueFilter),
            };
            if (!!process.env.IS_TEST_SERVER) {
                console.log("load more auditRequest", auditRequest);
            }
            const result = await projectConfigStoreDataContext.fetchAuditLog(auditRequest);
            newState.status = { inProgress: false, loaded: true };
            switch (result.status) {
                case "success": {
                    newState.error = { isError: false, error: undefined };
                    newState.data = {
                        auditLogRecords: [
                            ...((_a = state.data) === null || _a === void 0 ? void 0 : _a.auditLogRecords) || [],
                            ...result.result.records
                        ],
                        noMoreRecords: !result.result.haveMore
                    };
                    newState.time = { updatedAt: DateTimeUtils_1.DateTimeUtils.now() };
                    break;
                }
                case "error": {
                    newState.error = { error: new Error(result.reason), isError: true };
                    newState.data = undefined;
                    break;
                }
                case "unknownError": {
                    newState.error = { error: result.error, isError: true };
                    newState.data = undefined;
                    break;
                }
                default: {
                    newState.error = { error: new Error("unknown"), isError: true };
                    newState.data = undefined;
                }
            }
            (0, react_dom_1.unstable_batchedUpdates)(() => {
                setState(newState);
            });
        }
        catch (e) {
            const newState = {
                status: { inProgress: false, loaded: true },
                error: { isError: true, error: e },
            };
            (0, react_dom_1.unstable_batchedUpdates)(() => {
                setState(newState);
            });
        }
    }, [urlState, props.projectApiKey, (_a = state.data) === null || _a === void 0 ? void 0 : _a.auditLogRecords], lodash_1.default.isEqual);
    ////////////////////////////////////////////////
    // Return value
    ////////////////////////////////////////////////
    const stateFns = (0, use_custom_compare_1.useCustomCompareMemo)(() => ({
        getURLJSONModel,
        onViewChanged,
        onLoadMore,
    }), [
        getURLJSONModel,
        onViewChanged,
        onLoadMore,
    ], lodash_1.default.isEqual);
    const value = (0, use_custom_compare_1.useCustomCompareMemo)(() => ({
        state,
        urlState,
        stateFns,
    }), [
        state,
        urlState,
        stateFns,
    ], lodash_1.default.isEqual);
    return React.createElement(AuditLogPageDataContext.Provider, { value: value }, props.children);
};
exports.AuditLogPageDataProvider = AuditLogPageDataProvider;
